export default __webpack_public_path__ + "static/4contenido_pandaserver-1e995125d60575f57bcf4df7d5ff8e88.png";